import React, { Component, PropTypes } from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import { intlShape } from 'react-intl';
import classNames from 'classnames';

import BaseChargerMarker from 'AppComponents/MapMarker/Charger';
import Bubble from 'AppComponents/MapMarker/Bubble';

import ChargerPreview from '../../../ChargerPreview';


class ChargerMarker extends Component {

  static propTypes = {
    charger: PropTypes.shape({ pk: PropTypes.number }).isRequired,
    hovered: PropTypes.bool,
    intl: intlShape.isRequired,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    router: routerShape.isRequired,
    selected: PropTypes.bool,
  };

  static defaultProps = {
    hovered: false,
    onClick: null,
    onMouseEnter: null,
    onMouseLeave: null,
    selected: false,
  };

  static childContextTypes = {
    router: PropTypes.object,
    intl: intlShape,
  };

  getChildContext() {
    const { router, intl } = this.props;
    return { router, intl };
  }

  render() {
    const { selected, hovered, onClick, onMouseEnter, onMouseLeave } = this.props;
    return (
      <BaseChargerMarker
        className={classNames({ hovered })}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        charger={this.props.charger}
      >

        { selected ?
          <Bubble>

            <ChargerPreview {...this.props} />

          </Bubble>
        : null }

      </BaseChargerMarker>
    );
  }
}

export default ChargerMarker;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Home/components/ChargerMap/components/ChargerMarker/index.jsx